import { render, staticRenderFns } from "./AppUpdateBanner.vue?vue&type=template&id=26f3c5e2&scoped=true&"
import script from "./AppUpdateBanner.vue?vue&type=script&lang=js&"
export * from "./AppUpdateBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26f3c5e2",
  null
  
)

export default component.exports